<template>
  <div class="withdraw-manage">
    <van-search
      v-model="value"
      show-action
      label="姓名"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <div class="withdraw-tab">
      <van-tabs v-model="active" @change="onClick">
        <van-tab :title="parent_title"></van-tab>
        <van-tab :title="parent_two_title">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >

              <div class="w-tab-m" v-for="(item, index) in list" :key="index">
                <div class="w-tab-m-top">
                  <span class="left">姓名：{{ item.member.name }}，{{ item.member.phone }}</span>
                  <span class="right">充值类型：{{ item.device_type }}</span>
                </div>
                <div class="w-tab-m-price">
                  <span>旧余额：{{ item.old_balance }}</span>
                  <span>充值金额：{{ item.price }}</span>
                  <span>新余额：{{ item.new_balance }}</span>
                </div>
                <div class="w-tab-m-info">
                  <span>充值日期：{{ item.created_at }}</span>
                </div>
              </div>

            </van-list>
          </van-pull-refresh>
        </van-tab>

      </van-tabs>
    </div>

    <Floating toUrl="/users/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Search, Tab, Tabs, Empty, Image as VanImage, List, PullRefresh } from 'vant'

  export default {
    components: {
      [Search.name]: Search,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Empty.name]: Empty,
      [VanImage.name]: VanImage,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
    },
    name: 'sell',
    data () {
      return {
        value: '',
        active: 1,
        page: 1,
        list: [],
        parent_title: '会员列表',
        parent_two_title: '充值记录',
        loading: false,
        finished: false,
        refreshing: false,
      }
    },
    created () {
      //
    },
    methods: {
      onLoad () {
        this.$api.get('manage/rechargeList', {page: this.page, search:this.value}, r => {
          let data = r.data.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.last_page) {
            this.finished = true;
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = this.page + 1
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      onSearch() {
        this.list = []
        this.page = 1
        this.onLoad()
      },
      onClick(name, title) {
        if(name == 0){
          //this.$router.push({name: 'sell'})
          window.location.href = "/manage/recharge"
        }
      }
    }
  }
</script>

<style scoped>
  .withdraw-manage .withdraw-top{
    overflow: hidden;
    position: absolute;
    top: 18%;
    left: 5%;
    width: 90%;
    color:#ffffff;
    margin-top:10px;
  }
  .withdraw-manage .withdraw-top .w-top-l{
    float: left;
  }
  .withdraw-manage .withdraw-top .w-top-l span{
    font-size: 22px;
  }
  .withdraw-manage .withdraw-top .w-top-l p{
    margin: 0;
    font-size: 12px;
    padding-top:5px;
  }
  .withdraw-manage .withdraw-top .w-top-r{
    float: right;
  }
  .withdraw-manage .withdraw-top .w-top-r span{
    float: right;
    font-size: 13px;
    margin-top: 27px;
  }
  .withdraw-manage .withdraw-tab{

  }
  .withdraw-manage .withdraw-tab .w-tab-m{
    background: #ffffff;
    border-radius: 3px;
    margin-top: 10px;
    padding:10px;
    font-size: 13px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-top{
    overflow: hidden;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 6px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-top span{
    display: inline-block;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-price{
    margin: 8px 0;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 6px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-price span{
    display: inline-block;
    width: 32%;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/rechargeRecord.vue